import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'servicedesk-app-discovery.header',
		defaultMessage: 'Discover apps',
		description: 'Title of settings page',
	},
	headerNew: {
		id: 'servicedesk-app-discovery.header-new',
		defaultMessage: 'Explore apps',
		description: 'Title of settings page',
	},
	subHeaderJsm: {
		id: 'servicedesk-app-discovery.sub-header-jsm',
		defaultMessage:
			'Supercharge your service project with our favorite apps from the Atlassian Marketplace.',
		description: 'Description of the settings page, appearing under header',
	},
	categoryAssetManagement: {
		id: 'servicedesk-app-discovery.category-asset-management',
		defaultMessage: 'Asset management',
		description: 'Asset management category title',
	},
	categoryHelpCenterFormCustomization: {
		id: 'servicedesk-app-discovery.category-help-center-form-customization',
		defaultMessage: 'Help center & form customization',
		description: 'Help center & form customization category title',
	},
	categoryAgentProductivity: {
		id: 'servicedesk-app-discovery.category-agent-productivity',
		defaultMessage: 'Agent productivity',
		description: 'Agent productivity category title',
	},
	categoryReportingAnalytics: {
		id: 'servicedesk-app-discovery.category-reporting-analytics',
		defaultMessage: 'Reporting & Analytics',
		description: 'Reporting & Analytics category title',
	},
	categoryAlertingIncidentManagement: {
		id: 'servicedesk-app-discovery.category-alerting-incident-management',
		defaultMessage: 'Alerting & Incident Management',
		description: 'Alerting & Incident Management category title',
	},
	featureFlagOffError: {
		id: 'servicedesk-app-discovery.feature-flag-off-error',
		defaultMessage: 'This page is not yet available',
		description: 'Shown when accessing the page when feature flag is off',
	},
});
